export default __webpack_public_path__ + "static/media/video2.a2703484.mp4";